<template>
  <div class="card shadow-sm">
    <div class="card-header d-flex justify-content-between align-items-center">
      <h5 class="mb-0">🧪 Análisis registrados</h5>
      <button class="btn btn-sm btn-primary" @click="$emit('crear')">
        <font-awesome-icon icon="plus" class="me-1" /> Nuevo análisis
      </button>
    </div>

    <div class="table-responsive">
      <table class="table table-striped table-hover mb-0">
        <thead class="table-light">
          <tr>
            <th>ID</th>
            <th>Tipo</th>
            <th>Fecha</th>
            <th>Realizado por</th>
            <th>Método</th>
            <th class="text-end">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="analisis in analisisList" :key="analisis.id">
            <td>{{ analisis.id }}</td>
            <td>{{ analisis.tipo_analisis?.nombre }}</td>
            <td>{{ new Date(analisis.fecha_analisis).toLocaleDateString() }}</td>
            <td>{{ analisis.realizado_por }}</td>
            <td>{{ analisis.metodo }}</td>
            <td class="text-end">
              <button class="btn btn-sm btn-outline-secondary me-1" @click="$emit('ver', analisis.id)">
                <font-awesome-icon icon="eye" />
              </button>
              <button class="btn btn-sm btn-outline-primary me-1" @click="$emit('editar', analisis)">
                <font-awesome-icon icon="pen" />
              </button>
              <button class="btn btn-sm btn-outline-danger" @click="confirmarEliminar(analisis.id)">
                <font-awesome-icon icon="trash" />
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-if="error" class="alert alert-danger m-3">
      {{ error }}
    </div>
  </div>
</template>

<script>
import axios from '@/axios'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

export default {
  name: 'AnalisisList',
  components: { FontAwesomeIcon },
  data() {
    return {
      analisisList: [],
      error: null,
    }
  },
  methods: {
    async fetchAnalisis() {
      try {
        const res = await axios.get('/api/analisis')
        this.analisisList = res.data
      } catch (error) {
        this.error = 'Error al cargar los análisis'
        console.error(error)
      }
    },
    async confirmarEliminar(id) {
      if (!confirm('¿Seguro que querés eliminar este análisis?')) return
      try {
        await axios.delete(`/api/analisis/${id}`)
        this.fetchAnalisis()
      } catch (error) {
        this.error = 'Error al eliminar el análisis'
        console.error(error)
      }
    }
  },
  mounted() {
    this.fetchAnalisis()
  }
}
</script>

<style scoped>
.table th,
.table td {
  vertical-align: middle;
}
</style>
